module.exports = __webpack_public_path__ + "img/lock_clock_opsz20.ae1e2185.svg";